import { render, staticRenderFns } from "./bloodForm.vue?vue&type=template&id=38c63410"
import script from "./bloodForm.vue?vue&type=script&lang=js"
export * from "./bloodForm.vue?vue&type=script&lang=js"
import style0 from "./bloodForm.vue?vue&type=style&index=0&id=38c63410&prod&lang=css"
import style1 from "./bloodForm.vue?vue&type=style&index=1&id=38c63410&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports